import type {ApiError} from "./api";
import ApiService from "./api";
import type {ISiteAyar} from "@/model/site_ayar.ts";
import {type ISiteAyarDTO, mapSiteAyarDTOtoSiteAyar} from "@/model/site_ayar.dto";
import StorageService from "./storage";

class SiteAyarService {
  static _ayar: ISiteAyar | null = null;

  static async getSiteAyar(force: boolean = false): Promise<[ApiError, ISiteAyar]> {
    if (import.meta.env.VITE_API_SETTINGS === 'false') {
      if (SiteAyarService._ayar && !force) {
        return [null, SiteAyarService._ayar]
      }

      SiteAyarService._ayar = SiteAyarService._getEnvAyar();
      return [null, SiteAyarService._ayar];
    }

    const res = this._getApiAyar(force).catch<[ApiError, ISiteAyar]>((err) => {
      return [err, {} as ISiteAyar];
    });
    if (SiteAyarService._ayar && !force) {
      return [null, SiteAyarService._ayar];
    }
    return await res;
  }

  static async _getApiAyar(force: boolean = false): Promise<[ApiError, ISiteAyar]> {
    const lastFetch = StorageService.get<number>("salf2")
    if (lastFetch && Date.now() - lastFetch < 1000 * 60 * 5 && !force) { // 5 dakika içinde bir kez çalıştırılacak
      const ayar = StorageService.get<ISiteAyar>("site-ayar2")
      if (ayar) {
        SiteAyarService._ayar = ayar;
        return [null, SiteAyarService._ayar];
      }
    }
    const [err, resp] = await ApiService.get<ISiteAyarDTO>("site-ayar")
    if (err) {
      if (SiteAyarService._ayar && !force) {
        return [null, SiteAyarService._ayar];
      }
      return [err, {} as ISiteAyar]
    }
    SiteAyarService._ayar = mapSiteAyarDTOtoSiteAyar(resp!.data)
    StorageService.set("site-ayar2", SiteAyarService._ayar)
    StorageService.set("salf2", Date.now())
    return [null, SiteAyarService._ayar];
  }

  static _getEnvAyar(): ISiteAyar {
    return {
      title: JSON.parse(import.meta.env.VITE_YARISMA_ISIM.replace(/'/g, '"')),
      description: JSON.parse(import.meta.env.VITE_YARISMA_ACIKLAMA.replace(/'/g, '"')),
      language_list:parseJson(import.meta.env.VITE_YARISMA_DIL_LISTESI),
      country_list: parseJson(import.meta.env.VITE_YARISMA_ULKELER),
      login_type: import.meta.env.VITE_LOGIN_TYPE,
      contact_number: parseJson(import.meta.env.VITE_ILETISIM_NUMARALARI),
      logo: parseLogo(import.meta.env.VITE_LOGO),
    }
  }
}

function parseJson(jsonString: string): string[] {
  return jsonString ? JSON.parse(jsonString.replace(/'/g, '"')) : []
}

// VITE_LOGO tek URL ya da JSON dizi olabilir -> her zaman string[] dön
function parseLogo(raw: string): string[] {
  if (!raw) return []
  const s = raw.trim()
  return s.startsWith('[') ? parseJson(s) : [s]
}

export default SiteAyarService
